import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="relative min-h-screen">
            {/* Static Diagonal Gradient Background */}
            <div
                className="fixed inset-0 z-0"
                style={{
                    background: 'linear-gradient(135deg, rgb(59, 130, 246) 0%, rgb(236, 72, 153) 100%)'
                }}
            />

            {/* Navbar */}
            <nav className="fixed top-0 w-full z-50">
                <div className="relative w-full h-20 py-4">
                    <div
                        className="fixed flex items-center space-x-3"
                        style={{ left: '10%', top: '1.5rem' }}
                    >
                        <button 
                            onClick={() => navigate('/')}
                            className="flex items-center gap-3 text-white hover:opacity-80 transition-opacity duration-200"
                        >
                            <img src="/logo.png" alt="mifamli logo" className="h-12 w-12" />
                            <span className="text-3xl font-bold drop-shadow-lg">mifamli</span>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="relative z-10 min-h-screen flex items-center justify-center px-4 pt-32 pb-16">
                <div className="max-w-3xl mx-auto">
                    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-8 text-center">
                        Privacy Policy
                    </h1>
                    <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/30 text-left">
                        <p className="text-white/90 leading-relaxed mb-6">
                            <strong>Last updated:</strong> [Placeholder – update with date]
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            This privacy policy describes how mifamli ("we", "us", "our") collects, uses, and protects your information when you use our family management platform.
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            <strong>Information we collect:</strong> We collect information you provide when creating an account (name, email, profile photo via Google OAuth), family and member data, and content you add to the platform (todos, events, documents, etc.).
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            <strong>How we use it:</strong> We use your information to provide, maintain, and improve our services; to personalize your experience; and to communicate with you about your account.
                        </p>
                        <p className="text-white/90 leading-relaxed mb-4">
                            <strong>Data sharing:</strong> We do not sell your personal information. Data is shared only with family members you invite and as required by law.
                        </p>
                        <p className="text-white/90 leading-relaxed mb-6">
                            <strong>Contact:</strong> For questions about this policy, contact us at [placeholder@mifamli.com].
                        </p>
                        <p className="text-sm text-white/70 italic">
                            This is placeholder content. Please review and update before public launch.
                        </p>
                        <button
                            onClick={() => navigate('/')}
                            className="mt-8 px-8 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/50 rounded-xl text-white font-semibold text-lg hover:bg-white/30 transition-all duration-200"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;

